import { useApiQueryForCms } from 'mf_core/logout';
/** 1800000 ms (30 mins) */
const MAX_CACHE_TIME = 1800000;

export function useHelpMenuQuery(locale: string) {
  return useApiQueryForCms<HelpMenu>(
    `/cms/v1/help-menu-items?locale=${locale}`,
    undefined,
    { gcTime: MAX_CACHE_TIME, staleTime: MAX_CACHE_TIME }
  );
}
export type HelpMenu = {
  items?: Help[];
  total?: number;
};
export type Help = {
  isModel: boolean;
  onclick: string;
  openUrlInNewTab: boolean;
  title: string;
  trackingTag: string;
  url: string;
};
